export const TRIGGER_TYPE = {
    Status: 1,
    Form: 2,
    Scheduled: 3,
    Inquiry: 4,
    Channel: 5,
    ESignatureEnvelope: 6
};

export const TRIGGER_ACTION_TYPE = {
    FormSubmission: 1,
    ExitStatus: 2,
    StatusTransition: 3,
    EnterStatus: 4,
    ScheduledDaily: 5,
    ScheduledWeekly: 6,
    ScheduledMonthly: 7,
    ScheduledYearly: 8,
    FormESignaturesAllComplete: 9,
    FormESignaturesOneFailed: 10,
    FormESigsAnyESigComplete: 11,
    InquiryNewThread: 12,
    InquiryNewReply: 13,
    SignalFromChannel: 14,
    ESignatureEnvelopeComplete: 15,
    ESignatureEnvelopeAnySigned: 16
};

export const RULE_TYPE = {
    validation: "validation",
    action: "action",
    programWideProject: "programWideProject",
    program: "program"
};

export const ACTION_TYPE = {
    Validate: 1,
    DoNothing: 2,
    ChangeStatus: 3,
    SendCommunication: 4,
    SetDataField: 5,
    SetDeadline: 6,
    CallWebAdapter: 7,
    RunReport: 8,
    ClearAssignee: 9,
    GenerateAttachment: 10,
    SatisfyDeadline: 11,
    SignalToChannel: 12,
    PauseDeadline: 13,
    ResumeDeadline: 14,
    AddAccessGroup: 15,
    RemoveAccessGroup: 16,
    RequestESignature: 17,
    ClearDataField: 18
};

export const RULE_FREQUENCY = {
    OnlyFirstTime: 1,
    EveryTime: 2
};
